export function expiringCMNsReport(
  state={
    isFetching:false,
    error:null,
    pkg: null
  },
  action
) {
  switch (action.type) {
    case 'REQUEST_EXPIRING_CMNS_REPORT':
      return Object.assign({}, state, {
         isFetching: true
       })
    case 'RECEIVED_EXPIRING_CMNS_REPORT':
      return Object.assign({}, state, {
         isFetching: false,
         pkg: action.pkg,
         error:null
       })
    case 'FAILED_EXPIRING_CMNS_REPORT':
      return Object.assign({}, state, {
         isFetching: false,
         pkg: null,
         error: action.error
       })
    default:
      return state
  }
}
